import script from "./m-library-trending-sources.vue?vue&type=script&setup=true&lang=js"
export * from "./m-library-trending-sources.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__